import { Box, ClickAwayListener, Popover } from "@mui/material";
import { Dashboard } from "../../../../../types/files";
import EmailsContentCard from "../../../../molecules/home-companies/EmailsContentCard";

const EmailsModal: React.FC<{
    open: boolean,
    dashboard: Dashboard,
    anchorElement?: HTMLElement|null,
    onClose: () => void,
 }> = ({ open, dashboard, anchorElement, onClose }) => {
    return (<>
        <Popover open={open} anchorEl={anchorElement}>
            <ClickAwayListener onClickAway={onClose}>
                <Box width="fit-content" height="fit-content">
                    <EmailsContentCard dashboard={dashboard} />
                </Box>
            </ClickAwayListener>
        </Popover>
    </>);
}

export default EmailsModal;